<script>
  function resizeIframe(obj) {
    obj.style.height = obj.contentWindow.document.documentElement.scrollHeight + 'px';
  }
</script>
<div class="card bg-emphasis bg-opacity-25">
  <div class="card-header fw-bold small text-truncate text-uppercase" *ngIf="widget.showTitle">
    <div class="d-flex fw-bold small">
      <span class="flex-grow-1">
          {{widget.name}}
      </span>                    
      <span>
        <a class="button" (click)="refresh()">
          <i class="fa fa-refresh"></i>
        </a>
      </span>
    </div>
  </div>
  <div class="card-body p-0">
    <open-street-map #streetMap [style]="'height:' + widget.height + 'px'" [mapheight]="widget.height" [mapType]="config?.mapType" [geoJson]="config?.geoJson" (onHover)="onHover($event)" (onUnhover)="onUnhover($event)"></open-street-map>
    
  </div>
</div>